<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item>消息中心</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="infoform-box">
            <el-table
                ref="multipleTable"
                :data="messageData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="消息标题"
                >
                    <template slot-scope="scope">{{ scope.row.message_title }}</template>
                </el-table-column>
                <el-table-column
                    prop="fee_type"
                    label="时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="message_type"
                    label="类型"
                    width="180">
                </el-table-column>
            </el-table>
            <el-row>
                <el-col :span="8">
                    <div class="operate-box">
                        <el-checkbox>
                            <el-button @click="deleteSelection()">删除</el-button>
                            <el-button>标记已读</el-button>
                        </el-checkbox>
                    </div>
                </el-col>
                <el-col :span="16">
                    <!--<div class="pagination">-->
                        <!--<el-pagination-->
                            <!--background-->
                            <!--layout="prev, pager, next"-->
                            <!--:total="1000">-->
                        <!--</el-pagination>-->
                    <!--</div>-->
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            messageData: [{
                message_title: '日期筛选条件优化，客户关怀解放双手',
                fee_type: '2018-12-17',
                message_type: '系统通知'
            }, {
                message_title: '关于恢复开具电子发票的通知',
                fee_type: '2018-12-21',
                message_type: '系统通知'
            }, {
                message_title: '登录行为验证产品上线通知',
                fee_type: '2018-12-28',
                message_type: '系统通知'
            }],
            multipleSelection: []
        }
    },

    methods: {
        deleteSelection (rows) {
            console.log(rows)
        },
        handleSelectionChange (val) {
            this.multipleSelection = val
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";

    .infoform-box .pagination {
        margin-top: 24px;
        float: right;
    }
</style>
<style>
    .operate-box {
        margin-top: 20px;
        padding-left: 15px;
    }

    .operate-box .el-checkbox__label {
        margin-left: 30px;
    }
</style>
